var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Animation, PageTransition } from 'ionic-angular';
var SlideTransition = (function (_super) {
    __extends(SlideTransition, _super);
    function SlideTransition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SlideTransition.prototype.slidePositionView = function (nativeEle, ev) {
    };
    return SlideTransition;
}(PageTransition));
export { SlideTransition };
var SlideIn = (function (_super) {
    __extends(SlideIn, _super);
    function SlideIn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SlideIn.prototype.init = function () {
        console.log('slide in', this.opts);
        var targetDim = this.opts.ev.data && this.opts.ev.data.target && this.opts.ev.data.target.getBoundingClientRect();
        var ele = this.enteringView.pageRef().nativeElement;
        var slideZoom = new Animation(this.plt, ele.querySelector('.slide-content-wrap'));
        var slideWrap = new Animation(this.plt, ele.querySelector('ion-backdrop'));
        slideZoom.fromTo('transform', 'translateY(' + (targetDim.top - ele.querySelector('.slide-zoom').offsetTop) + 'px)', 'translateY(0)');
        slideWrap.fromTo('opacity', '0', '1');
        this
            .duration(333)
            .add(slideZoom)
            .add(slideWrap);
    };
    SlideIn.prototype.play = function () {
        var _this = this;
        this.plt.raf(function () {
            _this.slidePositionView(_this.enteringView.pageRef().nativeElement, _this.opts.ev);
            _super.prototype.play.call(_this);
        });
    };
    return SlideIn;
}(SlideTransition));
export { SlideIn };
var SlideOut = (function (_super) {
    __extends(SlideOut, _super);
    function SlideOut() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SlideOut.prototype.init = function () {
        var targetDim = this.opts.ev.data && this.opts.ev.data.target && this.opts.ev.data.target.getBoundingClientRect();
        var ele = this.leavingView.pageRef().nativeElement;
        var slideZoom = new Animation(this.plt, ele.querySelector('.slide-content-wrap'));
        var slideWrap = new Animation(this.plt, ele.querySelector('ion-backdrop'));
        slideZoom.fromTo('transform', 'translateY(0)', 'translateY(' + (targetDim.top - ele.querySelector('.slide-zoom').offsetTop) + 'px)');
        slideWrap.fromTo('opacity', '1', '0');
        this
            .duration(333)
            .add(slideZoom)
            .add(slideWrap);
    };
    return SlideOut;
}(SlideTransition));
export { SlideOut };
//# sourceMappingURL=slide-transitions.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ion2-image-slide/dist/components/slide-transitions.js
// module id = 721
// module chunks = 20